module.exports = __webpack_public_path__ + "img/0603-h.e3ba79bf.svg";